<template>
  <PrivacyEsRegulations v-if="locale == 'es'" />
  <PrivacyPtRegulations v-else />
</template>

<script setup lang="ts">
const { locale } = useI18n();
</script>
